import { TableDataTypesEnum } from "../../../enums/table/table-data-types.enum";
import { SortType } from "../../../services/api-services/shared/feature-response/sort.type";
import { TablesState } from "../interfaces/tables-state";
import { produce } from "immer";

export const sortDefaultDirection = function (type: TableDataTypesEnum): 'ASC' | 'DESC' {
    return type === TableDataTypesEnum.Date || type === TableDataTypesEnum.DateTime
        ? 'DESC'
        : 'ASC';
}
export const toggleSortingHandler = function (state: TablesState, tableId: string, key: string | null) {


    const nextState = produce(state[tableId], draft => {

        const currentSorting = draft.definitions.find(x => x.sortDirection != undefined); // Find the current sorting

        if (currentSorting) {
            if (currentSorting.key == key) { // toggle between ASC and DESC on the same column
                const current = currentSorting.sortDirection;
                currentSorting.sortDirection = current == 'ASC' ? 'DESC' :
                    current == null ? sortDefaultDirection(currentSorting.dataType) : 'ASC';
            } else { // change sorting to a new cloumn
                currentSorting.sortDirection = undefined;
                const newSortColumn = draft.definitions.find(x => x.key == key);
                if (newSortColumn)
                    newSortColumn.sortDirection = sortDefaultDirection(newSortColumn.dataType)
            }
        }

        draft.pagination.page = 0; // Reset to first page when sorting changes
    })

    return {
        ...state,
        [tableId]: { ...nextState }
    }
}

export const setSortingHandler = function (state: TablesState, tableId: string, key: string, direction: SortType) {

    // if (direction == null) return state;
    if (key == null) return state;

    const nextState = produce(state[tableId], draft => {
        const definitionToSort = draft.definitions.find(definition => definition.key == key);
        if (definitionToSort) {

            draft.definitions.forEach(element => {
                element.sortDirection = null;
            });
            const current = definitionToSort.sortDirection;

            definitionToSort.sortDirection = direction ?? (current == 'ASC' ? 'DESC' :
                current == null ? sortDefaultDirection(definitionToSort.dataType) : 'ASC');
        }

        draft.pagination.page = 0; // Reset to first page when sorting changes
    });

    return {
        ...state,
        [tableId]: { ...nextState }
    }
}